import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { DivipolaI } from 'src/app/modelos/Divipola';
import { VariableI } from 'src/app/modelos/variable';
import { VarParamI } from 'src/app/modelos/VariableParametrica';
import { ApiService } from 'src/app/servicios/api/api.service';
import { AppServiceService } from 'src/app/servicios/AppService.service';

@Component({
  selector: 'app-parametricasfivi',
  templateUrl: './parametricasfivi.component.html',
  styleUrls: ['./parametricasfivi.component.css']
})
export class ParametricasfiviComponent implements OnInit {

  ParametricasFIVI : VarParamI[];
  VariablesPara : VariableI[];
  existeParametrica : VariableI;
  page : number;
  page1 : number;
  page2 : number;
  page3 : number;
  page4 : number;
  ParametricaEditVaria : VarParamI;
  NombreParametricaEdit : string;
  ListadoDivipola : DivipolaI[];
  NuevaVariable : Boolean;
  NuevaVariableParametrica : VariableI;
  ActiBtnGuardar : Boolean;

  constructor(
    private api:ApiService,
    private router:Router,
    private appService:AppServiceService,
    private toastr: ToastrService
  ) { }

  ngOnInit(): void {
    this.api.getVariableParametricaFivi().subscribe(data=>{
      this.ParametricasFIVI = data;
    });
    this.ParametricaEditVaria = new VarParamI();
    this.NuevaVariable = false;
    this.NuevaVariableParametrica = new VariableI();
    this.ActiBtnGuardar = false;
  }

  Regresar(){
    this.router.navigate(['parametricas']);
  }

  EditarVariable(parametrica:VarParamI){
    this.ParametricaEditVaria = parametrica;
    this.NombreParametricaEdit = parametrica.nombre;
    if (parametrica.orden == 8 || parametrica.orden == 10){
      this.api.findAllDeptos().subscribe(Divi=>{
        this.ListadoDivipola = Divi;
      });
    } else if (parametrica.orden == 9 || parametrica.orden == 11){
      this.api.findAllDeptosMunis().subscribe(Divi=>{
        this.ListadoDivipola = Divi;
      });
    }else {
      this.api.getVariablesByIdParam(parametrica.id).subscribe(Result=>{
        this.VariablesPara = Result;
      });
    }
  }

  EditarParametrica(){
    if (this.ParametricaEditVaria.nombre == "" ){
      this.toastr.warning('Nombre requerido.', 'Advertencia!');
    } else {
      this.api.editarParametrica(this.ParametricaEditVaria).subscribe(result=>{
        if(result){
          this.toastr.success('Parametrica actualizada.', 'OK!');
          this.EditarVariable(this.ParametricaEditVaria);
        }
      }, error=>{
        this.toastr.error('La parametrica no fue actualizada.', 'Error!');
      });
    }
  }

  NuevoItemSuper(){
    this.NuevaVariableParametrica = new VariableI();
    if (this.NuevaVariable) {
      this.NuevaVariable = true;
      this.NuevaVariableParametrica.idvarparam = this.ParametricaEditVaria.id
      this.toastr.warning('Ingresar datos del nuevo item.', 'Advertencia!');
    } else {
      this.NuevaVariable = true;
      this.NuevaVariableParametrica.idvarparam = this.ParametricaEditVaria.id
    }
  }

  GuardarItemSuper(parametrica:VariableI){
    this.ActiBtnGuardar = true;
    if(parametrica.codigo == null || parametrica.codigo == ""){
      this.toastr.warning('Ingrese código.', 'Advertencia!');
      this.ActiBtnGuardar = false;
    } else if(parametrica.codigo.length < 1){
      this.toastr.warning('Código muy corto.', 'Advertencia!');
      this.ActiBtnGuardar = false;
    }  else if(parametrica.codigo.length > 99){
      this.toastr.warning('Código muy largo.', 'Advertencia!');
      this.ActiBtnGuardar = false;
    } else if(parametrica.nombre == null || parametrica.nombre == ""){
      this.toastr.warning('Ingrese nombre.', 'Advertencia!');
      this.ActiBtnGuardar = false;
    } else if(parametrica.nombre.length < 3){
      this.toastr.warning('Nombre muy corto.', 'Advertencia!');
      this.ActiBtnGuardar = false;
    } else if(parametrica.nombre.length > 50){
      this.toastr.warning('Nombre muy largo.', 'Advertencia!');
      this.ActiBtnGuardar = false;
    } else if(this.VerificarCodigoParametrica(parametrica.codigo)){
      this.toastr.warning('Existe código.', 'Advertencia!');
      this.ActiBtnGuardar = false;
    } else {
      this.api.nuevaVariableReporte(parametrica).subscribe(Result2=>{
        if(Result2){
          this.NuevaVariable = false;
          this.ActiBtnGuardar = false;
          this.toastr.success('Variable creada.', 'OK!');
          this.EditarVariable(this.ParametricaEditVaria);
        }
      }, error=>{
        this.toastr.error('La variable no fue creada.', 'Error!');
      });
    }
  }

  VerificarCodigoParametrica(codigo){
    this.existeParametrica = this.VariablesPara.find(function(parametrica) {
      if (parametrica.codigo === codigo) return parametrica;
      else return null;
    });
    if(this.existeParametrica != null) return true;
    else return false;
  }

  EditarItem(parametrica:VariableI){
    console.log(parametrica);
    if(parametrica.codigo == null || parametrica.codigo == ""){
      this.toastr.warning('Ingrese código.', 'Advertencia!');
      this.ActiBtnGuardar = false;
    } else if(parametrica.codigo.length < 1){
      this.toastr.warning('Código muy corto.', 'Advertencia!');
      this.ActiBtnGuardar = false;
    }  else if(parametrica.codigo.length > 99){
      this.toastr.warning('Código muy largo.', 'Advertencia!');
      this.ActiBtnGuardar = false;
    } else if(parametrica.nombre == null || parametrica.nombre == ""){
      this.toastr.warning('Ingrese nombre.', 'Advertencia!');
      this.ActiBtnGuardar = false;
    } else if(parametrica.nombre.length < 3){
      this.toastr.warning('Nombre muy corto.', 'Advertencia!');
      this.ActiBtnGuardar = false;
    } else if(parametrica.nombre.length > 50){
      this.toastr.warning('Nombre muy largo.', 'Advertencia!');
      this.ActiBtnGuardar = false;
    } else if(this.ParametricaEditVaria.id == 2 && parametrica.codsuper == ""){
      this.toastr.warning('Ingrese código superintendencia.', 'Advertencia!');
      this.ActiBtnGuardar = false;
    } else {
      this.api.nuevaVariableReporte(parametrica).subscribe(Result2=>{
        if(Result2){
          this.NuevaVariable = false;
          this.ActiBtnGuardar = false;
          this.toastr.success('Variable actualizada.', 'OK!');
          this.EditarVariable(this.ParametricaEditVaria);
        }
      }, error=>{
        this.toastr.error('La variable no fue actualizada.', 'Error!');
      });
    }
  }

}
